import { render, staticRenderFns } from "./CheckboxMultiSelect.vue?vue&type=template&id=befd6152"
import script from "./CheckboxMultiSelect.vue?vue&type=script&lang=js"
export * from "./CheckboxMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./CheckboxMultiSelect.vue?vue&type=style&index=0&id=befd6152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports